export default "__VITE_ASSET__a4af61fd__"